import { render } from "./ActionItems.vue?vue&type=template&id=db99469e&scoped=true"
import script from "./ActionItems.vue?vue&type=script&lang=js"
export * from "./ActionItems.vue?vue&type=script&lang=js"

import "./ActionItems.vue?vue&type=style&index=0&id=db99469e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db99469e"]])

export default __exports__